const RouteModule = {
  state: {
    route: null,
    router: null
  },
  mutations: {
  	set_route (state, route) {
      state.route = route     
    },
    set_router (state, router) {
      state.router = router
    }
  },
  getters: {
  	survay_id (state, getters, rootState) {
      return state.route.params.page
    },
    page_id (state, getters, rootState) {
      return state.route.params.stepId
    },
    router (state, getters, rootState) {
      return state.router
    },
    params (state) {
      return state.route.params
    }
  },
  actions: {
    dynamicPageLoad ({ dispatch, commit, state, rootState, getters }, payload) {

    }
  }
}

export default RouteModule

